import React from "react";
import KuikaSvg from "../../../../ui-kit/kuika-svg/kuika-svg";
import KuikaTemplateCard, {
  KuikaTemplateCardGrid,
  KuikaTemplateCardSkeleton
} from "../../../../ui-kit/kuika-template-card/kuika-template-card";
import { ShowcaseFrame } from "../_layout/showcase-frame";
import { SpecRow } from "../_layout/spec-row";
import { noop } from "../_layout/utils";

export const TemplateCardStory: React.FC = (): JSX.Element => {
  return (
    <ShowcaseFrame
      title="Template Card"
      componentName="KuikaTemplateCard"
      sourcePath="ui-kit/kuika-template-card"
      description="Gallery card for 'pick one of these' surfaces: cover artwork, a name, two lines of description, and its actions rising over the artwork on hover so the text you're reading to decide stays legible."
    >
      <SpecRow
        label="Gallery"
        caption="hover a card — it lifts 2px and the cover zooms 4%; both distances collapse to 0 under prefers-reduced-motion, the border/shadow/action-fade states still animate"
        align="stretch"
      >
        <div style={{ height: 460, width: "100%" }}>
          <KuikaTemplateCardGrid>
            <KuikaTemplateCard
              title="Customer Support Bot"
              description="Answers tickets from the shared inbox and escalates anything it isn't sure about to a human."
              imageUrl="/images/common/ai-bot.svg"
              badge="GPT-4"
              primaryAction={{ label: "Use", onClick: noop }}
              secondaryAction={{ label: "Preview", onClick: noop }}
            />
            <KuikaTemplateCard
              title="Sales Report Generator"
              description="Builds a weekly PDF from the CRM pipeline and emails it to the sales channel every Monday morning."
              coverIcon={<KuikaSvg name="report" width={32} height={32} />}
              primaryAction={{ label: "Use", onClick: noop }}
              secondaryAction={{ label: "Preview", onClick: noop }}
            />
            <KuikaTemplateCard
              title="Onboarding Checklist"
              description="Walks a new hire through their first-week tasks and pings their manager when one is skipped."
              coverIcon={<KuikaSvg name="check" width={32} height={32} />}
              selected
              primaryAction={{ label: "Use", onClick: noop }}
              secondaryAction={{ label: "Preview", onClick: noop }}
            />
          </KuikaTemplateCardGrid>
        </div>
      </SpecRow>
      <SpecRow
        label="Loading"
        caption="same frame and bands as the real card, so the swap to real content doesn't shift the grid"
        align="stretch"
      >
        <div style={{ height: 240, width: "100%" }}>
          <KuikaTemplateCardGrid>
            <KuikaTemplateCardSkeleton count={3} />
          </KuikaTemplateCardGrid>
        </div>
      </SpecRow>
    </ShowcaseFrame>
  );
};
